export const PROGRESS_BAR_START = 'fastcover.PROGRESS_BAR_START';
export const PROGRESS_BAR_END = 'fastcover.PROGRESS_BAR_END';



// WEBPACK FOOTER //
// ./app/containers/ProgressBar/constants.js